import Trans from '@/components/shared/Trans';
import translations from '@/components/Developments/developments.trans.json';

// These were previously plain module-level objects, computed once with
// `Trans()` at import time. `Trans()` resolves the active language from
// `localStorage` (`user_language`/`company_language`), which is only set
// once `UserSlice`'s user-data fetch resolves - a race against this
// module's (synchronous) first evaluation. Whichever loses that race gets
// permanently baked in for the tab's lifetime, unlike every other string
// on the page, which calls `Trans()` inline on each render and therefore
// always sees the up-to-date value (TBR-6751). Getter functions make these
// re-evaluate on every call instead.
export const getFiltersTransKeyNames = () => ({
  types: Trans(translations, 'Types'),
  locations: Trans(translations, 'Locations'),
  constructionsStatus: Trans(translations, 'ConstructionStatus'),
  status: Trans(translations, 'Status'),
  deliveryDate: Trans(translations, 'DeliveryDateRange'),
});

export const FILTERS_KEYS = {
  TYPES: 'types',
  LOCATIONS: 'locations',
  CONSTRUCTION_STATUS: 'constructionsStatus',
  STATUS: 'status',
  DELIVERY_DATE: 'deliveryDate',
  SEARCHER_TEXT: 'searcherText',
  ORIGIN: 'origin',
};

// See `getFiltersTransKeyNames` comment above - same reasoning (TBR-6751).
export const getSelectAllOptions = () => ({
  [FILTERS_KEYS.TYPES]: {
    id: -1,
    name: Trans(translations, 'AllDevelopmentTypes'),
  },
  [FILTERS_KEYS.LOCATIONS]: {
    id: -1,
    name: Trans(translations, 'AllDevelopmentLocations'),
  },
  [FILTERS_KEYS.CONSTRUCTION_STATUS]: {
    id: -1,
    name: Trans(translations, 'AllConstructionStatus'),
  },
});

export const DEVELOPMENT_STATUS_OPTIONS = {
  1: 'data_loading',
  2: 'commercialization',
  3: 'archived',
};

export const PARAMS_QUERY_KEYS = {
  COMMERCIALIZATION: 'commercialization',
  DATA_LOADING: 'data_loading',
  ARCHIVED: 'archived',
  TYPE: 'type',
  LOCATION: 'location',
  CONSTRUCTION_STATUS: 'construction_status',
};

// See `getFiltersTransKeyNames` comment above - same reasoning (TBR-6751).
export const getStatusFilterOptions = () => ({
  [PARAMS_QUERY_KEYS.COMMERCIALIZATION]: {
    id: 2,
    name: Trans(translations, 'Commercialization'),
  },
  [PARAMS_QUERY_KEYS.DATA_LOADING]: {
    id: 1,
    name: Trans(translations, 'DataLoading'),
  },
  [PARAMS_QUERY_KEYS.ARCHIVED]: {
    id: 3,
    name: Trans(translations, 'Archived'),
  },
});

export const ORIGIN_NAMES = {
  ORULO: 'Órulo',
  DWV: 'DWV',
};

export const ORIGIN_VALUES = {
  TOKKO: 'tokko',
  ORULO: 'orulo',
  DWV: 'dwv',
};

export const UNIVEN_INTEGRATIONS = [ORIGIN_VALUES.ORULO, ORIGIN_VALUES.DWV];

export const ORIGIN_NAMES_BY_VALUE = {
  orulo: ORIGIN_NAMES.ORULO,
  dwv: ORIGIN_NAMES.DWV,
};

export const PAGE_SIZE = 10;

/** Query tokens for `listing_edition_review` (filter_by_criteria). */
export const LISTING_EDITION_REVIEW = {
  PENDING: 'pending',
  REJECTED: 'rejected',
};

/** API keys in `listing_edition_review_counts`. */
export const LISTING_EDITION_REVIEW_COUNT_KEYS = {
  [LISTING_EDITION_REVIEW.PENDING]: 'pending_review',
  [LISTING_EDITION_REVIEW.REJECTED]: 'rejected_review',
};
